import dayjs from 'dayjs';

export type ClassificacaoKey = 'alerta' | 'controle' | 'equilibrio' | 'neutro';

export type ClassificacaoMeta = {
  label: string;
  bgColor: string;
  textColor: string;
};

export const CLASSIFICACAO_META: Record<ClassificacaoKey, ClassificacaoMeta> = {
  alerta: { label: 'Alta', bgColor: '#fde8e8', textColor: '#c0392b' },
  controle: { label: 'Média', bgColor: '#fdf3cd', textColor: '#856404' },
  equilibrio: { label: 'Baixa', bgColor: '#d4edda', textColor: '#155724' },
  neutro: { label: 'Neutro', bgColor: '#f5f5f5', textColor: '#555' },
};

const TIPO_LABELS: Record<string, string> = {
  inseto: 'Inseto',
  doenca: 'Doença',
  invasora: 'Invasora',
  nematoide: 'Nematoide',
  climatica: 'Climática',
  visita: 'Visita',
  stand: 'Contagem Stand',
  produtividade: 'Produtividade',
  solo: 'Solo',
  inimigo_natural: 'Inimigo Natural',
  manutencao_melhoria: 'Manutenção',
  recomendacao: 'Recomendação',
  aplicacao: 'Aplicação',
  anotacao: 'Anotação',
  aspecto_geral: 'Aspecto Geral',
  tarefa: 'Tarefa',
  semeadura_afericao: 'Aferição Semeadura',
  colheita_afericao: 'Aferição Colheita',
  aplicacao_afericao: 'Aferição Aplicação',
};

export const formatTipo = (tipo: string): string => TIPO_LABELS[tipo] ?? tipo;

export const toTitleCase = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const formatPlantioTooltip = (inicio?: string, fim?: string): string => {
  if (!inicio) return '';
  const inicioFmt = dayjs(inicio).format('DD/MM/YY');
  if (fim && fim !== inicio) {
    return `${inicioFmt} à ${dayjs(fim).format('DD/MM/YY')}`;
  }
  return inicioFmt;
};
